import { styled } from "@mui/material/styles";
import makeStyles from "@mui/styles/makeStyles";

import { IconButton } from "@mui/material";
import { colors } from "@zapalacorp/tokens";

export const QuestionOptionsContainer = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  gap: "8px",
  flex: 1,
  justifyContent: "flex-end",
}));

export const OptionTag = styled("div")(() => ({
  display: "flex",
  padding: "4px 8px",
  justifyContent: "center",
  alignItems: "center",
  borderRadius: "4px",
  backgroundColor: "#E6E9EF",
  maxWidth: "100px",
}));

export const OptionName = styled("span")(() => ({
  color: colors.gray600,
  fontFamily: "Manrope",
  fontSize: "12px",
  fontWeight: 600,
  lineHeight: "16px",
  letterSpacing: "0.5px",
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
}));

export const EditOptionButton = styled(IconButton)(() => ({
  height: "32px",
  width: "32px",
  color: colors.gray600,
}));

const styles = makeStyles(() => ({
  optionTag: {
    display: "flex",
    padding: "4px 8px",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "4px",
    backgroundColor: "#E6E9EF",
    maxWidth: "100px",
  },
}));

export default styles;
